exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.countryMark[data-v-aa100de6] {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: #fff;\n  z-index: 10000;\n}\n.countryUl li[data-v-aa100de6] {\n  padding-left: 0.293rem;\n  padding-right: 0.293rem;\n  line-height: 1.013rem;\n  font-size: 0.347rem;\n  color: #333333;\n  border-bottom: 1px solid #fafafa;\n  overflow: hidden;\n}\n.countryUl li .fl[data-v-aa100de6] {\n  float: left;\n}\n.countryUl li .fr[data-v-aa100de6] {\n  float: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa100de6","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/countryCode.vue
// module id = 314
// module chunks = 32